(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-feeding-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ADULT_PCT = { low: 2, average: 3, active: 4, highly: 5 };
    var PUPPY_PCT = { low: 7, average: 8, active: 9, highly: 10 };

    function formatGrams(g) {
      if (g >= 1000) {
        return (g / 1000).toFixed(2).replace(/\.00$/, '') + ' kg';
      }
      return Math.round(g) + ' g';
    }

    function getChecked(form, name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }

    function init(form) {
      var resultEl = form.querySelector('[data-rs-fc-result]');
      var errorEl = form.querySelector('[data-rs-fc-error]');
      var ageWrap = form.querySelector('[data-rs-fc-age-wrap]');
      var shopLink = form.querySelector('[data-rs-fc-shop]');
      var shopLinkBase = shopLink ? shopLink.getAttribute('href') : null;

      function syncPetType() {
        var pet = getChecked(form, 'pet');
        if (ageWrap) ageWrap.style.display = pet === 'puppy' ? '' : 'none';
      }

      form.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'pet') syncPetType();
      });
      syncPetType();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        errorEl.hidden = true;

        var pet = getChecked(form, 'pet') || 'adult';
        var activity = getChecked(form, 'activity') || 'average';
        var weeks = parseInt(getChecked(form, 'weeks') || '1', 10);
        var weight = parseFloat(form.querySelector('#rs-fc-weight').value);

        if (!weight || weight <= 0) {
          resultEl.hidden = true;
          errorEl.hidden = false;
          return;
        }

        var pctTable = pet === 'puppy' ? PUPPY_PCT : ADULT_PCT;
        var pct = pctTable[activity];
        var dailyGrams = weight * (pct / 100) * 1000;
        var periodGrams = dailyGrams * 7 * weeks;
        var packs = Math.ceil(periodGrams / 1000);

        form.querySelector('[data-rs-fc-daily]').textContent = formatGrams(dailyGrams);
        form.querySelector('[data-rs-fc-pct]').textContent =
          pct + '% of body weight' + (pet === 'puppy' ? ' (puppy range 7-10%)' : '');
        form.querySelector('[data-rs-fc-per-meal-2]').textContent = formatGrams(dailyGrams / 2);
        form.querySelector('[data-rs-fc-per-meal-3]').textContent = formatGrams(dailyGrams / 3);
        form.querySelector('[data-rs-fc-period-total]').textContent = formatGrams(periodGrams);
        form.querySelector('[data-rs-fc-weeks-label]').textContent =
          weeks + (weeks === 1 ? ' week' : ' weeks');
        form.querySelector('[data-rs-fc-packs]').textContent = packs;

        if (shopLink && shopLinkBase) {
          /* Carry the plan to /collections/raw-food so the mini-calculator
             on that page can prefill itself and show a welcome banner.
             Format: plan=packs:weeks:pet:activity (order-sensitive). */
          var plan = [packs, weeks, pet, activity].join(':');
          shopLink.setAttribute('href', shopLinkBase + '?plan=' + encodeURIComponent(plan));
        }

        resultEl.hidden = false;
      });

      form.addEventListener('reset', function () {
        setTimeout(function () {
          resultEl.hidden = true;
          errorEl.hidden = true;
          syncPetType();
          if (shopLink && shopLinkBase) shopLink.setAttribute('href', shopLinkBase);
        }, 0);
      });
    }

    document.querySelectorAll('[data-rs-feeding-calculator]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
